export { initCookiePolicyScript } from '../client-script/dist/xsite-ui-gaming.cookie-banner-client-script.esm.js';
import { jsx } from '@emotion/react';
import { UIEventType, withUIEvent } from '@xsite-ui/common.event-tracker';
import { CancelCircleFill } from '@xsite-ui/gaming.icons/cancel-circle-fill';
import { CheckCircleFill } from '@xsite-ui/gaming.icons/check-circle-fill';
import 'react';
import { useTranslation } from 'react-i18next';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { css } from '@xsite-ui/common.style';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var cookieContainer = function cookieContainer(theme) {
  var _theme$mobile$baseCol, _theme$mobile, _theme$desktop$color, _theme$desktop;

  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 0;\n  z-index: 11;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 15px;\n  width: 100%;\n  background-color: ", ";\n  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.25);\n  transform: translateY(0);\n  transition: all ease-in-out 0.7s;\n\n  &.hidden_banner {\n    transform: translateY(100%);\n    box-shadow: none;\n\n    @media (min-width: 1024px) {\n      transform: translateY(-100%);\n    }\n  }\n\n  @media (min-width: 1024px) {\n    position: static;\n    justify-content: center;\n    background-color: ", ";\n  }\n"])), [(_theme$mobile$baseCol = (_theme$mobile = theme.mobile) === null || _theme$mobile === void 0 ? void 0 : _theme$mobile.baseColor6) !== null && _theme$mobile$baseCol !== void 0 ? _theme$mobile$baseCol : '#f5f7f7'], [(_theme$desktop$color = (_theme$desktop = theme.desktop) === null || _theme$desktop === void 0 ? void 0 : _theme$desktop.color4) !== null && _theme$desktop$color !== void 0 ? _theme$desktop$color : '#f5f7f7']);
};
var text = function text(theme) {
  var _theme$mobile2, _theme$desktop2;

  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.688em;\n  line-height: 1.2;\n  letter-spacing: -0.1px;\n\n  @media (min-width: 1024px) {\n    color: ", ";\n    font-size: 0.75em;\n  }\n"])), (_theme$mobile2 = theme.mobile) === null || _theme$mobile2 === void 0 ? void 0 : _theme$mobile2.baseColor2, [(_theme$desktop2 = theme.desktop) === null || _theme$desktop2 === void 0 ? void 0 : _theme$desktop2.baseColor1, '#ffffff']);
};
var cookieLink = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: inherit;\n  font-weight: 700;\n  text-decoration-line: underline;\n\n  :hover {\n    text-decoration-line: none;\n  }\n"])));
var iconWrapper = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 10px;\n"])));
var closingIcon = function closingIcon(theme) {
  var _theme$mobile3, _theme$desktop3;

  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  display: none;\n  cursor: pointer;\n\n  &.v-icon {\n    path {\n      fill: ", ";\n    }\n\n    @media (max-width: 1023px) {\n      display: block;\n    }\n  }\n\n  &.x-icon {\n    opacity: 0.5;\n    padding: 1px;\n\n    path {\n      fill: ", ";\n    }\n\n    @media (min-width: 1024px) {\n      display: block;\n    }\n  }\n"])), [(_theme$mobile3 = theme.mobile) === null || _theme$mobile3 === void 0 ? void 0 : _theme$mobile3.baseColor10, '#090909'], [(_theme$desktop3 = theme.desktop) === null || _theme$desktop3 === void 0 ? void 0 : _theme$desktop3.baseColor1, '#66666b']);
};

/** @jsxRuntime classic */
var closeIconUiEventOptions = {
  type: UIEventType.click,
  category: 'CookiePolicy',
  action: 'click',
  label: 'User clicked on close button'
};
var CookieBanner = function CookieBanner(_ref) {
  var geo = _ref.geo;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var is_in_european_union = geo.is_in_european_union;
  var messageText = t('GamingCookiePolicy.message');
  var linkText = t('GamingCookiePolicy.link');
  var CloseIconWithUiEvent = withUIEvent(jsx("div", {
    css: iconWrapper,
    "data-testid": "closing-icon-wrapper",
    id: "cookies-policy-close_wrapper"
  }, jsx(CheckCircleFill, {
    css: closingIcon,
    className: "v-icon"
  }), jsx(CancelCircleFill, {
    css: closingIcon,
    className: "x-icon"
  })), closeIconUiEventOptions);
  return jsx("div", {
    css: cookieContainer,
    className: "cookies-policy hidden_banner",
    "data-geo-eu": is_in_european_union,
    "data-role-id": "cookie-policy"
  }, jsx("p", {
    css: text
  }, messageText, "\xA0", jsx("a", {
    css: cookieLink,
    "data-automation-id": "cookie-policy",
    href: "/cookie"
  }, linkText)), jsx(CloseIconWithUiEvent, null));
};

export { CookieBanner };
